export enum HotelClinicStatus {
    PENDING = "PENDING",
    IN_TRANSIT = "IN_TRANSIT",
    DONE = "DONE",
}

export enum HotelClinicStatusActionType {
    CREATE_TASK_PLAN_PAGE = 1,

    // update
    UPDATE_TASK_PLAN_PAGE = 10,
    MOBILE_APP_TASK_PROGRESS_UPDATE = 11,
    ADD_PASSENGER_TO_TASK_PLAN_PAGE = 12,
    REMOVE_PASSENGER_FROM_TASK_PLAN_PAGE = 13,
}

export enum IHotelClinicPassengerType {
    CLINIC = "clinic",
    CUSTOM = "custom",
}

export enum HotelClinicNames {
    ELIT_HAIR = "ELIT_HAIR",
    RHINO_MEDICAL = "RHINO_MEDICAL",
    YES_SMILE = "YES_SMILE",
}

export const HOTEL_CLINIC_NAME_LABELS: Record<HotelClinicNames, string> = {
    [HotelClinicNames.ELIT_HAIR]: "Elit Klinik",
    [HotelClinicNames.RHINO_MEDICAL]: "Rhino Medical",
    [HotelClinicNames.YES_SMILE]: "Yes Smile",
};
